import { Inject, Injectable } from '@angular/core';
import { API_ENDPOINTS, ApiEndpoints, ApiResponse } from '@contracts';
import { ApiCilent } from '@core';
import { Observable } from 'rxjs';
import {
  AnalysisTemplate,
  CreateTemplatePayload,
  GroupAnalysisTemplateApi,
  ReorderTemplatePayload,
  UpdateTemplatePayload,
} from './group-analysis.interface';

@Injectable({
  providedIn: 'root',
})
export class GroupAnalysisService {
  constructor(
    private apiClient: ApiCilent,
    @Inject(API_ENDPOINTS)
    private readonly endpoints: ApiEndpoints,
  ) {}

  getTemplateList(): Observable<ApiResponse<GroupAnalysisTemplateApi[]>> {
    return this.apiClient.get({
      path: 'group-analysis',
      query: {
        type: 'view',
      },
    });
  }

  getTemplateDetailById(query: any): Observable<ApiResponse<any>> {
    return this.apiClient.get({
      path: 'group-analysis',
      query: {
        ...query,
        type: 'specific',
      },
    });
  }

  getEnergySummary(query: any): Observable<ApiResponse<any>> {
    return this.apiClient.get({
      path: 'dashboard/group_energy_summary/',
      query,
      domain: 'fast',
    });
  }

  getDailyEnergy(query: any): Observable<ApiResponse<any>> {
    return this.apiClient.get({
      path: 'dashboard/group_energy_period',
      query,
      domain: 'fast',
    });
  }

  createTemplate(payload: CreateTemplatePayload): Observable<ApiResponse<any>> {
    return this.apiClient.post({
      path: 'group-analysis/',
      body: payload,
    });
  }

  updateTemplate(id: number | string, payload: UpdateTemplatePayload) {
    return this.apiClient.put({
      path: `group-analysis/`,
      body: { ...payload, id },
    });
  }

  deleteTemplate(id: number | string) {
    return this.apiClient.delete({
      path: `group-analysis/`,
      query: { id },
    });
  }
  reorderTemplates(body: ReorderTemplatePayload) {
    return this.apiClient.patch({
      path: `group-analysis/`,
      body,
    });
  }
}
